import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { HelpComponent } from './help/help.component';
import { RolesComponent } from './roles/roles.component';
import { LogoutComponent } from './logout/logout.component';
import { AuthGaurdService } from '../service/auth-gaurd.service';
import { MyDocsComponent } from './upload/my-docs/my-docs.component';
import { ImpersonateUserComponent } from './impersonate-user/impersonate-user.component';
import { ErrorComponent } from './error/error.component';
import { CommPlanComponent } from '../commission/comm-plan/comm-plan.component';
import { KpimasterComponent } from '../commission/kpimaster/kpimaster.component';
import { ManageUsersComponent } from '../personnel/manage-users/manage-users.component';
import { ErrorAuthFailedComponent } from './errorauthfailed/errorauthfailed.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin', 'Supervisor', 'Sales Representative', 'Sales Channel Admin'] } },
  { path: 'logout', component: LogoutComponent },
  { path: 'other', loadChildren: './other/other.module#OtherModule' },
  { path: 'error', component: ErrorComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin', 'Supervisor', 'Sales Representative', 'Sales channel Admin'] } },
  { path: 'errorauthfailed', component: ErrorAuthFailedComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin', 'Supervisor', 'Sales Representative','Sales Channel Admin'] } },
  { path: 'unauthorized', component: UnauthorizedComponent},
  { path: 'compl', component: CommPlanComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] } },
  { path: 'kpi', component: KpimasterComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] } },
  { path: 'users', component: ManageUsersComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] } },
  { path: 'impersonate-user', component: ImpersonateUserComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] } },
  { path: 'roles', component: RolesComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] } },
  { path: 'help', component: HelpComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin', 'Supervisor', 'Sales Representative', 'Sales Channel Admin'] } },
  { path: 'my-docs', component: MyDocsComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin', 'Supervisor'] } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule { }
